// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "应用光伏发电系统",
      "tec": "王帅杰",
      "week": "1-12周",
      "add": "教学楼B座218自控"
    },
    {
      "sub": "光伏电站运行与故障检修",
      "tec": "杜远卓",
      "week": "1-8周",
      "add": "教学楼C座304教务"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "电力系统继电保护",
      "tec": "程珊珊",
      "week": "4,6,8,10,12周",
      "add": "教学楼B座218自控"
    },
    {
      "sub": "能源经济基础",
      "tec": "刘钰彤",
      "week": "1-8周",
      "add": "教学楼B座218自控"
    },
    {
      "sub": "就业创业指导",
      "tec": "赵明明王梓",
      "week": "5-9周",
      "add": "教学楼C座305教务"
    },
    {
      "sub": "科技文献检索",
      "tec": "李明飞",
      "week": "1-4周",
      "add": "（1-4周[07-08节]）"
    },
    0
  ],
  "3": [
    {
      "sub": "光伏电站运行与故障检修",
      "tec": "杜远卓",
      "week": "1,3,5,7周",
      "add": "教学楼C座304教务"
    },
    {
      "sub": "风电场运行与检修",
      "tec": "刘姝",
      "week": "1-12周",
      "add": "教学楼D座122新能"
    },
    0,
    0,
    {
      "sub": "国家安全教育",
      "tec": "李健",
      "week": "1-4周",
      "add": "教学楼C座305教务"
    }
  ],
  "4": [
    {
      "sub": "应用光伏发电系统",
      "tec": "王帅杰",
      "week": "1-12周",
      "add": "教学楼B座218自控"
    },
    {
      "sub": "电力系统继电保护",
      "tec": "程珊珊",
      "week": "3-13周",
      "add": "教学楼B座218自控"
    },
    0,
    0,
    0
  ],
  "5": [
    0,
    {
      "sub": "风电场运行与检修",
      "tec": "刘姝",
      "week": "1-12周",
      "add": "教学楼D座321文法"
    },
    {
      "sub": "国家安全教育",
      "tec": "李健",
      "week": "1-4周",
      "add": "教学楼C座305教务"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
